import {parsePhoneNumberWithError} from 'libphonenumber-js';

const tryConversionToE164Format = (input) => {
  try {
    const phoneNumber = parsePhoneNumberWithError(input, 'CA');

    if (!phoneNumber.isValid()) {
      return {
        originalPhoneNumber: input,
        e164Format: null,
        isValid: false,
        reasonNotValid: 'Invalid phone number',
      };
    }

    if (phoneNumber.country !== 'CA') {
      return {
        originalPhoneNumber: input,
        e164Format: null,
        isValid: false,
        reasonNotValid: 'Only Canadian numbers are allowed',
      };
    }

    return {
      originalPhoneNumber: input,
      e164Format: phoneNumber.format('E.164'),
      isValid: true,
      reasonNotValid: null,
    };
  } catch (error) {
    return {
      originalPhoneNumber: input,
      e164Format: null,
      isValid: false,
      reasonNotValid: error?.message || 'Invalid phone number',
    };
  }
};

export default tryConversionToE164Format;
